/** Ambiente de tour: APP (perfil) vs SIMULADOR (cockpit). */

export type TourAmbiente = 'APP' | 'SIMULADOR';

const EMBED_KEY = 'ac_cockpit_embed';
const PANEL_ACTIVE_MSG = 'ac-embed-panel-active';

export function isCockpitEmbed(): boolean {
  try {
    if (sessionStorage.getItem(EMBED_KEY) === '1') return true;
    if (window.self !== window.top) return true;
  } catch {
    /* cross-origin top access */
    return true;
  }
  return false;
}

/**
 * No simulador há vários iframes montados (abas ocultas).
 * Só o painel visível deve rodar auto-tour / captura do perfil.
 */
export function isEmbedPanelActive(): boolean {
  if (!isCockpitEmbed()) return true;
  try {
    if (document.visibilityState === 'hidden') return false;
    const fe = window.frameElement as HTMLElement | null;
    if (!fe) return true;
    const style = window.getComputedStyle(fe);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    if (style.opacity === '0') return false;
    if (fe.offsetWidth < 2 || fe.offsetHeight < 2) return false;
    return true;
  } catch {
    return true;
  }
}

/** Aguarda o iframe do perfil ficar ativo (troca de aba no cockpit). */
export function waitUntilEmbedPanelActive(
  timeoutMs = 120_000,
): Promise<boolean> {
  if (isEmbedPanelActive()) return Promise.resolve(true);

  return new Promise((resolve) => {
    let done = false;
    const finish = (ok: boolean) => {
      if (done) return;
      done = true;
      cleanup();
      resolve(ok);
    };

    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type !== PANEL_ACTIVE_MSG) return;
      if (isEmbedPanelActive()) finish(true);
    };

    const onVis = () => {
      if (isEmbedPanelActive()) finish(true);
    };

    let intervalId = 0;
    const cleanup = () => {
      window.removeEventListener('message', onMessage);
      document.removeEventListener('visibilitychange', onVis);
      if (intervalId) window.clearInterval(intervalId);
      if (timer) window.clearTimeout(timer);
    };

    window.addEventListener('message', onMessage);
    document.addEventListener('visibilitychange', onVis);
    intervalId = window.setInterval(() => {
      if (isEmbedPanelActive()) finish(true);
    }, 400);

    const timer = window.setTimeout(() => finish(false), timeoutMs);
  });
}

/** Parent (cockpit) avisa o iframe ativo que pode iniciar tour do perfil. */
export function notifyEmbedPanelActive(iframe: HTMLIFrameElement | null | undefined) {
  try {
    iframe?.contentWindow?.postMessage(
      { type: PANEL_ACTIVE_MSG },
      window.location.origin,
    );
  } catch {
    /* ignore */
  }
}

export { PANEL_ACTIVE_MSG };
